export default function createFormData (values, newFilesToUpload, filesStoredInDB) {
    const form = new FormData();
    form.append('name', values.name);
    form.append('cuit', values.cuit);
    form.append('telephone', values.telephone);
    form.append('email', values.email);
    form.append('category', values.rubro);
    form.append('store_address.street', values.addressStreet);
    form.append('store_address.number', values.addressNumber);
    form.append('store_address.postal_code', values.postalCode);
    form.append('store_address.county', values.county);
    form.append('store_address.province', values.province);
    form.append('store_address.metadata', JSON.stringify({ floor: values.commerceFloor }));
    newFilesToUpload.forEach((file, index) => {
        form.append(`file${index}`, file.blobFile);
    });
    form.append('files', JSON.stringify(filesStoredInDB));

    return form;
};
